import { render, staticRenderFns } from "./OffsetBlock.vue?vue&type=template&id=0e4f9e77&"
import script from "./OffsetBlock.vue?vue&type=script&lang=js&"
export * from "./OffsetBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports